module.exports = __webpack_public_path__ + "img/navbar-3.dcab4880.svg";